var _path, _path2, _path3, _circle, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVacation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 22s4-5 12-5 12 5 12 5M2.667 24.667h.074c.828 0 1.645.192 2.385.563l.873.436a3.855 3.855 0 0 0 3.863-.24l.138-.093a3.606 3.606 0 0 1 4 0v0a3.606 3.606 0 0 0 4 0v0a3.606 3.606 0 0 1 4 0l.139.093a3.855 3.855 0 0 0 3.862.24l.873-.436a5.333 5.333 0 0 1 2.385-.563h.074M2.667 27.333h.074c.828 0 1.645.193 2.385.563l.873.437a3.855 3.855 0 0 0 3.863-.24L10 28a3.606 3.606 0 0 1 4 0v0a3.606 3.606 0 0 0 4 0v0a3.606 3.606 0 0 1 4 0l.139.092a3.855 3.855 0 0 0 3.862.24l.873-.436a5.333 5.333 0 0 1 2.385-.563h.074",
    stroke: "#7460C2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.396 11.152 5.38 13.567S4.99 9.531 8.853 8.496c3.863-1.036 5.543 2.656 5.543 2.656Z",
    stroke: "#7460C2",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m9.888 12.36 1.726 6.439M8.853 8.496l-.345-1.288",
    stroke: "#7460C2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 8,
    r: 3.25,
    stroke: "#7460C2",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 13.333v1.334M29.333 8h1.334M24 2.667V1.333M28 12l.943.943M20 4l-.943-.943M28 4l.943-.943M20 12l-.943.943M18.667 8h-1.334",
    stroke: "#7460C2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacation);
export default __webpack_public_path__ + "static/media/vacation.3d84a35435c9c99f9e4707d0afba50c9.svg";
export { ForwardRef as ReactComponent };